<script setup lang="ts">
</script>

<template>
    <div class="height-100 width-100 flex-container align-middle align-center">
        <Icon
            icon="loader-2"
            class="sy-spin sy-icon-small "
        />
    </div>
</template>
